import {
  ArticlePreview,
  type ArticlePreviewMostPopular,
  ArticlePreviewMostPopular as ArticlePreviewMostPopularSchema,
} from '@/app_lib/types/ArticlePreview';

/**
 * Maps a “most popular” API row into a full `ArticlePreview` for recirc cards.
 * Kept in a standalone module (no article page UI imports) so Jest can unit test without lucide/styled churn.
 */
export function mostPopularToArticlePreview(mostPopular: ArticlePreviewMostPopular): ArticlePreview | undefined {
  const parsed = ArticlePreviewMostPopularSchema.safeParse(mostPopular);
  if (!parsed.success) {
    return;
  }

  const mp = parsed.data;

  /** Must match `sections.nodes[0].databaseId` so `getPrimarySection` resolves the eyebrow on recirc cards. */
  const injectedSectionDatabaseId = 1;

  /** merge defaults so `ArticlePreview` validates (e.g. `newsletters`). */
  const merged = {
    authors: mp.authors,
    classification: {
      primaryPostTag: {
        databaseId: -1,
        name: '',
        url: '/',
      },
    },
    databaseId: -1,
    dateGmt: mp.dateGmt,
    excerpt: '',
    id: '',
    image: mp.image,
    imageAlt: '',
    newsletters: { nodes: [] as { name: string; slug: string }[] },
    /** `ArticlePreview.primarySectionId` is parsed from string; `"1"` → `1` to align with the injected section node. */
    primarySectionId: String(injectedSectionDatabaseId),
    sections: {
      nodes: [
        {
          databaseId: injectedSectionDatabaseId,
          name: mp.sectionName,
          url: mp.sectionUrl,
        },
      ],
    },
    slug: '',
    title: mp.title,
    url: mp.url,
  };

  const result = ArticlePreview.safeParse(merged);
  return result.success ? result.data : undefined;
}
